import styled from 'styled-components';

import { Container as Card } from '~/components/Card/styles';

export const Container = styled(Card)`
  padding: 30px;
`;
